import React, { Fragment } from 'react';
import Spinner from 'src/ui/library/Spinner/Spinner';
import ContentParser from 'src/ui/library/ContentParser';
import classNames from 'classnames';
import Button from 'src/ui/library/Button';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { Edit /*Warning*/ } from '@material-ui/icons';
import intl from 'react-intl-universal';
import _ from 'lodash';

export default function ProfileInfoPres({
  profileId,
  showCancelEditlModal,
  onCancelModal,
  onConfirmModal,
  isLoading,
  dynamicContent,
  onFormChange,
  onCancel,
  onEdit,
  onSave,
  onValidate,
  isEditable,
  validationError,
  isPhoneValid,
}) {
  const formClass = classNames({
    'profile-form-detail': true,
    editmode: isEditable,
  });

  if (isLoading) {
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  }

  if (!dynamicContent || _.isEmpty(dynamicContent)) return null;

  return (
    <Fragment>
      {/*<div className="profile-warning">
        <Warning color="error" className="icon" /> <span className="text">{intl.get('profile.details.warningMessage')}</span>
  </div>*/}
      {showCancelEditlModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('profile.details.buttons.cancelEdit')}
          confirmText={intl.get('profile.details.buttons.continueEdit')}
          onCancel={onCancelModal}
          onConfirm={onConfirmModal}>
          {intl.get('cases.details.messages.confirmMessage')}
        </ConfirmDialog>
      )}

      <section className={formClass}>
        <div className="form-parser">
          <ContentParser
            key={`${isEditable}-${profileId}`}
            readOnly={!isEditable}
            data={dynamicContent}
            showLabels={false}
            numberOfColumns={3}
            debug={false}
            onChange={onFormChange}
            onValidate={onValidate}
          />
        </div>
      </section>
      <section className="profile-actions">
        {isEditable ? (
          <div className="save-cancel-wrapper">
            <Button styleType="secondary" onClick={onCancel} className="action-button">
              {intl.get('profile.details.buttons.cancel')}
            </Button>
            <Button className="action-button" onClick={onSave} disabled={validationError || !isPhoneValid}>
              {intl.get('profile.details.buttons.save')}
            </Button>
          </div>
        ) : (
          <Fragment>
            <div className="edit-delete-wrapper">
              <a className="link" onClick={onEdit}>
                <Edit className="icon" /> <span className="text">{intl.get('profile.details.buttons.edit')}</span>
              </a>
            </div>
          </Fragment>
        )}
      </section>
    </Fragment>
  );
}
